import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE = ""; // falder tilbage til OG image fra index.html hvis tom
const SITE_NAME = "Løftebarometeret";
const BASE_URL =
    (typeof window !== "undefined" && window.location?.origin) ||
    "https://loftebarometeret.dk";

/**
 * Generisk SEO-komponent — overrider per-page title, description, canonical,
 * Open Graph og Twitter-cards. Fallbacker til værdier sat i public/index.html.
 */
export default function Seo({
    title,
    description,
    path = typeof window !== "undefined" ? window.location.pathname : "/",
    image = DEFAULT_IMAGE,
    type = "website",
    keywords,
    structuredData,
}) {
    const fullTitle = title
        ? `${title} | ${SITE_NAME}`
        : `${SITE_NAME} — Dansk politisk tillid`;
    const url = `${BASE_URL}${path}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="da_DK" />
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}
            <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
}
